import {
  removeEmptyValues,
  SeoConfig,
  SeoOpenGraph,
  SeoOpenGraphImage,
} from '@common';

import { SeoData } from '../../models/seo/seo-data.interface';

export function formatSeoData(data?: SeoConfig): SeoData | undefined {
  if (!data) {
    return undefined;
  }

  const seoData: SeoData = {
    description: data.seoDescription,
    keywords: data.seoKeywords?.join(','),
    og: formatSeoOpenGraph(data.seoOpenGraph),
    title: data.seoTitle,
  };

  return removeEmptyValues(seoData);
}

export function formatSeoOpenGraph(
  data?: SeoOpenGraph,
): SeoOpenGraph | undefined {
  if (!data) {
    return undefined;
  }

  return {
    description: data.description,
    image: formatSeoOpenGraphImage(data.image),
    locale: data.locale,
    siteName: data.siteName,
    title: data.title,
    type: data.type,
  };
}

export function formatSeoOpenGraphImage(
  data?: SeoOpenGraphImage,
): SeoOpenGraphImage | undefined {
  if (!data) {
    return undefined;
  }

  return {
    alt: data.alt,
    height: data.height,
    type: data.type,
    url: data.url,
    width: data.width,
  };
}
